import { IPaymentMethods, TPaymentMethodsData } from './types';

export const normalizedFullPaymentMethods = (
  data: TPaymentMethodsData,
  showWithId?: boolean,
): IPaymentMethods => {
  const entries = Object.entries(data?.paymentMethods);

  const paymentMethods = data?.paymentMethods
    ? entries.map(([code, name]) => {
        return {
          label: showWithId ? `${name} (${code})` : (name as string),
          value: code,
        };
      })
    : [];

  return {
    merchantTerminalId: data?.merchantTerminalId as number,
    paymentMethods,
  };
};
